import { ChevronDown } from "lucide-react";
import React from "react";
import { cn } from "@/lib/utils";

export interface ExpandToggleProps {
	expanded: boolean;
	onToggle: () => void;
	/** Already translated label shown while collapsed, e.g. "Visa alla (10)". */
	showLabel: string;
	/** Already translated label shown while expanded, e.g. "Dölj". */
	hideLabel: string;
	/** Id of the element the toggle controls. */
	controls?: string;
	className?: string;
}

/**
 * Text button with a rotating chevron for showing/hiding a block of content
 * ("Visa alla (10)" ⇄ "Dölj"). Used by the batch summary boxes where the list
 * is collapsed by default so that a long list of issues doesn't push the
 * actual batch content off screen.
 */
const ExpandToggle: React.FC<ExpandToggleProps> = ({
	expanded,
	onToggle,
	showLabel,
	hideLabel,
	controls,
	className,
}) => (
	<button
		type="button"
		onClick={onToggle}
		aria-expanded={expanded}
		aria-controls={controls}
		className={cn(
			"inline-flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap rounded-sm border-0 bg-transparent p-0 text-sm font-medium text-blue-700 underline-offset-2 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
			className
		)}
	>
		{expanded ? hideLabel : showLabel}
		<ChevronDown
			aria-hidden
			className={cn("h-4 w-4 shrink-0 transition-transform", expanded && "rotate-180")}
		/>
	</button>
);

export default ExpandToggle;
